import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-timer-counter',
  template: `
    <ng-container>{{this.timer | timerFormat}}</ng-container>`,
  styleUrls: [],
})
export class TimerCounterComponent implements OnInit, OnDestroy {
  @Input()
  public time: number;
  @Input()
  public interval: number;
  @Output()
  public endTimerHandler: EventEmitter<void>;
  @Output()
  public startTimerHandler: EventEmitter<void>;
  @Output()
  public timerHandler: EventEmitter<number>;
  public timer: number;
  private timerInterval: any;

  constructor() {
    this.time = 0;
    this.interval = 1000;
    this.endTimerHandler = new EventEmitter<void>();
    this.startTimerHandler = new EventEmitter<void>();
    this.timerHandler = new EventEmitter<number>();
  }

  ngOnInit() {
    this.initVariables();
  }

  ngOnDestroy(): void {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }

  private initVariables() {
    this.timer = this.time;
    this.initTimer();
  }

  private initTimer() {
    if (this.timer === 0) {
      return;
    }
    this.startTimerHandler.emit();
    this.timerInterval = setInterval(() => {
      this.timer--;
      this.timerHandler.emit(this.timer);
      if (this.timer === 0) {
        this.endTimerHandler.emit();
        clearInterval(this.timerInterval);
      }
    }, this.interval);
  }
}
